import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { completeOAuthCallback } from "../lib/oauth";
import { useSession } from "../state";

export function AuthCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refreshSession, refreshMe } = useSession();
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const code = params.get("code");
    const error = params.get("error_description") || params.get("error");
    if (error) { setErr(decodeURIComponent(error)); return; }
    if (!code) { setErr("missing authorization code"); return; }

    (async () => {
      try {
        await completeOAuthCallback(code);
        // Pull tokens into context, then load /me, before navigating —
        // otherwise the router renders the unauthenticated landing page.
        await refreshSession();
        await refreshMe();
        nav("/", { replace: true });
      } catch (e: any) {
        setErr(e?.message || "sign-in failed");
      }
    })();
  }, [params, nav, refreshSession, refreshMe]);

  return (
    <div className="min-h-screen grid place-items-center text-ink-soft">
      {err ? (
        <div className="max-w-md text-center">
          <p className="text-coral-dark mb-3">sign-in failed</p>
          <p className="text-sm">{err}</p>
          <a href="/login" className="btn-ghost mt-4 inline-block">try again</a>
        </div>
      ) : (
        <span className="animate-pulse">finishing sign-in…</span>
      )}
    </div>
  );
}
